import { createContext } from "react";
import { useEffect, useMemo, useState } from "react";
import { getComparator, stableSort } from "../Helper/sort.helper";
import { filterGames } from "../Helper/filter.helper";
export const GameContext = createContext();

export const GameContextProvider = ({ children }) => {
  const [gameInfo, setGameInfo] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [sort, setSort] = useState({
    order: "desc",
    orderBy: "yearPublished",
    ignoredValues: [0],
  });

  useEffect(() => {
    fetch("gameData/gameData.json")
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        setGameInfo(response);
      });
  }, []);

  const filteredGameInfo = useMemo(
    () =>
      stableSort(
        filterGames(gameInfo, filterText),
        getComparator(sort.order, sort.orderBy, sort.ignoredValues)
      ),
    [gameInfo, filterText, sort]
  );

  return (
    <GameContext.Provider
      value={{ filteredGameInfo, filterText, setFilterText, sort, setSort }}
    >
      {children}
    </GameContext.Provider>
  );
};
